
import { apiRequest } from './client';
import { catalogConfig } from '../config/catalog';

export default async function getSkus(id_scroll, signal) {
  if (!id_scroll || id_scroll === "") {
    return null;
  }

  let params = {
    cnpj: catalogConfig.cnpj,
  }

  const response = await apiRequest(`/search/v2/scroll/${id_scroll}`, { params, signal });

  if (response?.skus) {
    response.skus = response.skus.filter(i =>
      !i.images?.[0]?.url_ds?.includes("nofigure")
    );
  }

  return response;
}
